import '@f-fertighaus/layout/PageHeader/SSR/PageHeaderSSR'
import '@f/components/PageSharing'
import '@js/common/site-wide'

import React from 'react'
import { createRoot } from 'react-dom/client'

import { QuizApp } from '@f/applications/QuizApp'

void (() => {
  const mountPoint = document.querySelector('.js-quiz-app')

  const root = createRoot(mountPoint)

  root.render(<QuizApp quizConfig={window['quiz_config']} />)
})()
